import ErrorToast from "@components/Common/ErrorTost";

export function isClosed(hourOfUse: any) {
    let isClosedShop: boolean = false;
    let hour: any[] = JSON.parse(JSON.stringify(hourOfUse)).filter(
        (element: any) =>
            (element.HeureDebut_Matin === "" &&
                element.HeureFin_Matin !== "") ||
            (element.HeureDebut_Matin !== "" &&
                element.HeureFin_Matin === "") ||
            (element.HeureDebut_soir === "" && element.HeureFin_soir !== "") ||
            (element.HeureDebut_soir !== "" && element.HeureFin_soir === "")
    );

    if (hour.length !== 0) {
        isClosedShop = true;
    } else {
        isClosedShop = false;
    }

    return isClosedShop;
}

export async function getApkTemplateDateModification(
    template: any,
    iuudApk: any
) {
    const response = await fetch(
        `${process.env.REACT_APP_C_AND_C}/getApkTemplateDateModification/${iuudApk}`,
        {
            method: "GET",
        }
    );

    const responseData = await response.json();

    if (!response.ok) {
        throw new Error(responseData.message || "Upload failed");
    }

    if (
        template.template.DateModification !== responseData.DateModification &&
        responseData.DateModification !== null
    ) {
        return 0;
    }
    return true;
}

export function getPattern(orders: any, selectedRows: any, t: any) {
    let pattern = "";

    if (orders.localPattern && orders.localPattern !== "") {
        const label = orders.localPattern.label;
        if (label === t("Technical problem")) {
            pattern = "PROBLEME TECHNIQUE";
        } else if (label === t("Out of stock")) {
            pattern = "RUPTURE DE STOCK";
        } else if (label === t("Annual closure")) {
            pattern = "FERMETURE ANNUELLE";
        } else {
            pattern = label;
        }
    } else if (
        orders.isPauseOrders &&
        selectedRows &&
        selectedRows.length > 0
    ) {
        pattern = selectedRows[0].motif_interompre ?? selectedRows[0].pattern;
    }

    return pattern;
}

export function buildSavedData({
    selectedRows,
    schema,
    etat,
    itemActivation,
    ItemSalesMethods,
    ItemPayementChoice,
    options,
    loyaltyAccount,
    hourOfUse,
    localOptionComposite,
    fuseau_horaire,
    orders,
    pattern,
}: {
    selectedRows: any;
    schema: any;
    etat: any;
    itemActivation: any;
    ItemSalesMethods: any;
    ItemPayementChoice: any;
    options: any;
    loyaltyAccount: any;
    hourOfUse: any;
    localOptionComposite: any;
    fuseau_horaire: any;
    orders: any;
    pattern: any;
}): any {
    return {
        shopId: selectedRows[0]?.shopId ?? null,
        schemaFranchise: schema,
        etat_boutique: etat,
        orderactive: itemActivation[1]?.active ?? false,
        vente_livraison: ItemSalesMethods[2]?.active ?? false,
        vente_a_emporter: ItemSalesMethods[1]?.active ?? false,
        vente_surplace: ItemSalesMethods[0]?.active ?? false,
        payement_caisse: ItemPayementChoice[1]?.active ?? false,
        payement_cb: ItemPayementChoice[0]?.active ?? false,
        client_anonyme: options.activateButton ?? false,
        info_client_anonyme: options.mandatoryEmail ?? false,
        payement_fid: loyaltyAccount?.isAuthorized ?? false,
        horraire_ouverture: hourOfUse,
        joignable_si_annulee: options.validatingOrder ?? false,
        parametre: localOptionComposite,
        fuseau_horaire: fuseau_horaire,
        interompre_commande: orders.isPauseOrders ?? false,
        interompre_indetermine: orders.interrompreIndeterliné ?? false,
        interompre_jusqua:
            orders.interompreJusqua === " Invalid date Invalid date"
                ? ""
                : orders.interompreJusqua,
        motif_interompre: pattern,
        timetogo: orders.timePrepartion,
        paramlivraison: orders.dataPrice,
    };
}

export function buildLocalOptionComposite(
    optionComposite: any,
    selectedRows: any
): any {
    return {
        CMD_DIFFERE: optionComposite.CMD_DIFFERE,
        REGLEGRATUITE:
            optionComposite.REGLEGRATUITE !== ""
                ? optionComposite.REGLEGRATUITE
                : selectedRows[0]?.["composite Products"]?.REGLEGRATUITE ?? "",
        licenceGodia: optionComposite.licenceGodia,
    };
}
export async function validateFormData(
    t: any,
    ItemSalesMethods: any[],
    ItemPayementChoice: any[],
    optionComposite: any,
    isShopClosed: boolean,
    orders: any,
    overLaps: any[],
    isErreur: boolean,
    ccSetup: () => Promise<void>
): Promise<boolean> {
    let valid = true;

    try {
        if (
            ItemSalesMethods[0]?.active === false &&
            ItemSalesMethods[1]?.active === false &&
            ItemSalesMethods[2]?.active === false
        ) {
            ErrorToast(
                t("Attention, you must activate at least one mode of sale.")
            );
            valid = false;
        } else if (
            ItemPayementChoice.length > 0 &&
            ItemPayementChoice[0]?.active === false &&
            ItemPayementChoice[1]?.active === false
        ) {
            ErrorToast(
                t(
                    "Please note that you must activate at least one payment method."
                )
            );
            valid = false;
        } else if (
            Object.keys(optionComposite).length > 0 &&
            optionComposite?.licenceGodia?.ActivationGodia === 1 &&
            optionComposite?.licenceGodia?.licenceGodia !== "" &&
            !/^[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}-[A-F0-9]{5}$/.test(
                optionComposite?.licenceGodia?.licenceGodia
            )
        ) {
            ErrorToast(t("Warning, please enter a valid interconnection key."));
            valid = false;
        } else if (isShopClosed === true) {
            ErrorToast(
                t(
                    "Attention, no schedule has been entered, which means that the shop will be considered closed."
                )
            );
            valid = false;
        } else if (
            Object.keys(orders).length > 0 &&
            orders?.delivery < 60 &&
            orders?.onTheSpot < 60 &&
            orders?.toTake < 60 &&
            !isErreur &&
            overLaps.every(
                (element: any) =>
                    element.HeureDebut_Matin === false &&
                    element.HeureFin_Matin === false &&
                    element.HeureDebut_soir === false &&
                    element.HeureFin_soir === false &&
                    element.inputDebut_Matin === false &&
                    element.inputFin_Matin === false &&
                    element.inputDebut_Soir === false &&
                    element.inputFin_Soir === false
            )
        ) {
            await ccSetup();
        }
    } catch (error) {
        console.error("Validation error:", error);
        ErrorToast(t("An unexpected error occurred during validation."));
        valid = false;
    }

    return valid;
}

export async function uploadApkTemplate(
    selectedRows: any[],
    formData: FormData
): Promise<any> {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_C_AND_C}/Setting/setApkTemplate/${selectedRows[0]?.iuudApk}`,
            {
                method: "POST",
                body: formData,
            }
        );

        if (!response.ok) {
            return false;
        }

        return true;
    } catch (error: any) {
        console.error("Upload error:", error);
        throw new Error(
            error.message || "An unexpected error occurred during the upload."
        );
    }
}
